const refRoutes = [
    {
        path: '/reference-data/dashboard',
        name: 'Dashboard',
        icon: 'null',
    },
    {
        path: '/simulation',
        name: 'Simulation',
        icon: 'null',
        children: [
            {
                path: '/reference-data/simulation',
                name: 'Bloc Data',
            },
            {
                path: '/reference-data/simulation-trade360',
                name: 'Trade 360',
            },
        ],
    },
    {
        path: '/data-model',
        name: 'Data Model',
        icon: 'null',
        children: [
            {
                path: '/reference-data/data-dictionary',
                name: 'Data Dictionary',
            },
            {
                path: '/reference-data/group-setup',
                name: 'Group Setup',
            },
            {
                path: '/reference-data/group-configuration',
                name: 'Group Configuration',
            },
        ],
    },
    {
        path: '/ingestion',
        name: 'Ingestion',
        icon: 'null',
        children: [
            {
                path: '/reference-data/source-setup',
                name: 'Source Setup',
            },
            {
                path: '/reference-data/source-configuration',
                name: 'Source Configuration',
            },
            {
                path: '/reference-data/group-source-field-map',
                name: 'Group Source Field Map',
            },
            {
                path: '/reference-data/data-imports',
                name: 'Data Imports',
            },
        ],
    },
    {
        path: '/data-governance',
        name: 'Data Governance',
        icon: 'null',
        children: [
            {
                path: '/reference-data/matching-rules',
                name: 'Matching Rules',
            },
            {
                path: '/reference-data/golden-copy-rules',
                name: 'Golden Copy Rules',
            },
            {
                path: '/reference-data/data-quality-checks',
                name: 'Data Quality Checks',
            },
            {
                path: '/reference-data/data-enrichment',
                name: 'Data Enrichment',
            },
        ],
    },
    {
        path: '/extraction',
        name: 'Extraction',
        icon: 'null',
        children: [
            {
                path: '/reference-data/push-configuration',
                name: 'Push Configuration',
            },
            {
                path: '/reference-data/push-rules',
                name: 'Push Rules',
            },
            // {
            //     path: '/reference-data/report-configuration',
            //     name: 'Report Configuration',
            // },
            // {
            //     path: '/reference-data/report-group-field-map',
            //     name: 'Report Group Field Map',
            // },
            // {
            //     path: '/reference-data/report-schedulers',
            //     name: 'Report Schedulers',
            // },
            {
                path: '/reference-data/report-dashboard',
                name: 'Reports',
            },
        ],
    },
    {
        path: '/workflows',
        name: 'Workflows',
        icon: 'null',
        children: [
            {
                path: '/reference-data/event-setup',
                name: 'Event Setup',
            },
            {
                path: '/reference-data/event-queues',
                name: 'Event Queues',
            },
            {
                path: '/reference-data/event-monitor',
                name: 'Event Monitor',
            },
        ],
    },
    {
        path: '/explorer',
        name: 'Explorers',
        icon: 'null',
        view: 1,
        children: [
            {
                path: '/reference-data/blocdata-explorer',
                name: 'Source Data Explorer',
            },
            {
                path: '/reference-data/groupdata-explorer',
                name: 'Group Data Explorer',
            },
            {
                path: '/reference-data/refdata-goldencopy',
                name: 'Golden Copy Explorer',
            },
            {
                path: '/reference-data/view-explorer',
                name: 'View Explorer',
            },
        ],
    },

    {
        path: '/entitlement',
        name: 'Entitlements',
        icon: 'null',
        children: [
            {
                path: '/entitlement/user',
                name: 'Users',
            },
            {
                path: '/entitlement/roles',
                name: 'Roles',
            },
            {
                path: '/entitlement/role-auths',
                name: 'Role Configurations',
            },
        ],
    },
];

const refVotersPoc = [
    {
        path: '/reference-data/dashboard',
        name: 'Dashboard',
        icon: 'null',
    },
    {
        path: '/data-model',
        name: 'Data Model',
        icon: 'null',
        children: [
            {
                path: '/reference-data/data-dictionary',
                name: 'Data Dictionary',
            },
            {
                path: '/reference-data/group-setup',
                name: 'Group Setup',
            },
            {
                path: '/reference-data/group-configuration',
                name: 'Group Configuration',
            },
        ],
    },
    {
        path: '/ingestion',
        name: 'Ingestion',
        icon: 'null',
        children: [
            {
                path: '/reference-data/source-setup',
                name: 'Source Setup',
            },
            {
                path: '/reference-data/source-configuration',
                name: 'Source Configuration',
            },
            {
                path: '/reference-data/group-source-field-map',
                name: 'Group Source Field Map',
            },
            {
                path: '/reference-data/data-imports',
                name: 'Data Imports',
            },
        ],
    },
    {
        path: '/data-governance',
        name: 'Data Governance',
        icon: 'null',
        children: [
            {
                path: '/reference-data/matching-rules',
                name: 'Matching Rules',
            },
            {
                path: '/reference-data/golden-copy-rules',
                name: 'Golden Copy Rules',
            },
            {
                path: '/reference-data/data-quality-checks',
                name: 'Data Quality Checks',
            },
            {
                path: '/reference-data/data-enrichment',
                name: 'Data Enrichment',
            },
        ],
    },
    {
        path: '/extraction',
        name: 'Extraction',
        icon: 'null',
        children: [
            {
                path: '/reference-data/report-dashboard',
                name: 'Reports',
            },
        ],
    },
    {
        path: '/workflows',
        name: 'Workflows',
        icon: 'null',
        children: [
            {
                path: '/reference-data/event-setup',
                name: 'Event Setup',
            },
            {
                path: '/reference-data/event-queues',
                name: 'Event Queues',
            },
            {
                path: '/reference-data/event-monitor',
                name: 'Event Monitor',
            },
        ],
    },
    {
        path: '/explorer',
        name: 'Explorers',
        icon: 'null',
        view: 1,
        children: [
            {
                path: '/reference-data/blocdata-explorer',
                name: 'Source Data Explorer',
            },
            {
                path: '/reference-data/groupdata-explorer',
                name: 'Group Data Explorer',
            },
            {
                path: '/reference-data/refdata-goldencopy',
                name: 'Golden Copy Explorer',
            },
        ],
    },
];

export {refRoutes,refVotersPoc};
